// extracted by mini-css-extract-plugin
export default {"templateCard":"TemplateView_templateCard__ZINNl"};